import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { getArticleImage } from '@/mocks/article-images';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'featured';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  const isFeatured = variant === 'featured';
  const imageUrl = getArticleImage(article.slug);

  return (
    <Link
      to={`/article/${article.slug}`}
      className={`group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden ${
        isFeatured ? 'lg:flex' : ''
      }`}
    >
      <div
        className={`relative overflow-hidden bg-background-200 ${
          isFeatured ? 'lg:w-2/5 lg:min-h-[280px]' : 'w-full h-48'
        }`}
      >
        <img
          src={imageUrl}
          alt={article.title}
          title={`${article.title} - 做爱指南`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      <div className={`p-5 ${isFeatured ? 'lg:w-3/5 lg:flex lg:flex-col lg:justify-center' : ''}`}>
        <div className="flex items-center gap-3 mb-2">
          <span className="text-xs text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full whitespace-nowrap">
            {article.tags[0]}
          </span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
        </div>

        <h3
          className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 ${
            isFeatured ? 'text-xl' : 'text-base'
          }`}
        >
          {article.title}
        </h3>

        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>

        <div className="flex items-center gap-1 mt-3 text-sm text-primary-600 font-medium">
          <span>阅读全文</span>
          <i className="ri-arrow-right-line text-xs"></i>
        </div>
      </div>
    </Link>
  );
}